import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { SummaryTableEntry } from '../../context-discovery-services/models/summary-table-entry.model';
import { Equipment } from '../../context-discovery-services/models';

@Component({
  selector: 'adminapp-summary-assets',
  templateUrl: './summary-assets.component.html',
  styleUrls: ['./summary-assets.component.scss']
})
export class SummaryAssetsComponent {
  listOfTypesOfEquipments = new Array<SummaryTableEntry>();
  _isUnifiedFlowEnabled: boolean;

  @Input()
  set isUnifiedFlowEnabled(unifiedFlowEnabled: boolean) {
    if (this._isUnifiedFlowEnabled !== unifiedFlowEnabled) {
      this._isUnifiedFlowEnabled = unifiedFlowEnabled;
    }
  }

  @Input()
  isAssetIdentificationRequired = false;

  @Input()
  isModelPresent = false;

  @Input()
  isLoading = false;

  @Input()
  set equipment(equipment: Array<Equipment>) {
    if (!equipment || equipment.length === 0) {
      return;
    }

    const temp = [];
    _.each(equipment, function (equip) {
      temp.push(new SummaryTableEntry(equip.label, equip.confirmedAssetCount));
    });

    this.listOfTypesOfEquipments = temp;
  }

  @Output() viewAssetsEventEmitter = new EventEmitter<void>();

  onGoToViewAssets() {
    if (this.viewAssetsEventEmitter) {
      this.viewAssetsEventEmitter.emit();
    }
  }

  constructor() { }

}
